import React from 'react';

// Import typefaces
import 'typeface-montserrat';
import 'typeface-merriweather';

import { rhythm } from '../utils/typography';

class Bio extends React.Component {
  render() {
    const profilePic = 'https://avatars.io/twitter/randolphebrown';

    return (
      <p
        style={{
          marginBottom: rhythm(2.5),
        }}
      >
        <img
          src={profilePic}
          alt={`Randy Brown`}
          style={{
            float: 'left',
            marginRight: rhythm(1 / 4),
            marginBottom: 0,
            borderRadius: '50%',
            width: rhythm(2),
            height: rhythm(2),
          }}
        />
        Written by <strong>Randy Brown</strong>{' '}
      </p>
    )
  }
}

export default Bio;



// WEBPACK FOOTER //
// ./src/components/Bio.js